const styles = {
  wrapper: 'flex flex-col items-start',
  imageWrapper: 'overflow-hidden w-full rounded-2',
  descriptionWrapper: 'flex items-center mt-2 md:mt-4 w-full',
  description:
    'text-body2 text-gray-3 font-semibold line-clamp-3 md:line-clamp-2',
};

export default styles;
